import React from "react";

import {Container} from './styles';

const Footer: React.FC = () =>{
    return (
        <Container>
            <div className="box">
                <div className="boxFooter">
                    <div className="title">
                        <h6>Lorem Ipsum</h6>
                    </div>
                    <ul>
                        <li>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Dolores hic qui dicta, ut cum sint deleniti ad at inventore itaque expedita fugit voluptate ipsum sequi est, ratione facere. Maxime, suscipit?</li>
                    </ul>
                </div>
                <div className="boxFooter">
                    <div className="title">
                        <h6>Lorem Ipsum</h6>
                    </div>
                    <ul>
                        <li>Dolor sit</li>
                        <li>Dolor sit</li>
                        <li>Dolor sit</li>
                        <li>Dolor sit</li>
                        <li>Dolor sit</li>
                    </ul>
                </div>
                <div className="boxFooter">
                    <div className="title">
                        <h6>Lorem Ipsum</h6>
                    </div>
                    <ul>
                        <li>Dolor sit</li>
                        <li>Dolor sit</li>
                        <li>Dolor sit</li>
                        <li>Dolor sit</li>
                        <li>Dolor sit</li>
                    </ul>
                </div>
                <div className="boxFooter">
                    <div className="title">
                        <h6>Lorem Ipsum</h6>
                    </div>
                    <ul>
                        <li>Dolor sit</li>
                        <li>Dolor sit</li>
                        <li>Dolor sit</li>
                        <li>Dolor sit</li>
                        <li>Dolor sit</li>
                    </ul>
                </div>
            </div>
            <div className="copy">
                <div className="copyTitle">
                    <h6>© GodoyDev</h6>
                </div>
            </div>
        </Container>
    )
}

export default Footer;